import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { userSignUp } from "../services/signService";

export default function UserProtected() {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = location.state?.formData || {};

  const [protectedData, setProtectedData] = useState({
    name: "",
    birth: "",
  });

  const handleChange = (e) => {
  const { name, value } = e.target;
  setProtectedData({ ...protectedData, [name]: value.trim() });
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestData = {
      username: userInfo.username,
      password: userInfo.password,
      name: userInfo.name,
      email: userInfo.email,
      birth: userInfo.birth,
      address: userInfo.address,
      phone: userInfo.phone,
      protect_name: protectedData.name,
      protect_birth: protectedData.birth,
    };

    console.log("최종 전송 데이터:", requestData);

    try {
      const response = await userSignUp(requestData);

      if (response.success === false) {
        alert(response.message || "회원가입 실패. 다시 시도해주세요.");
      } else {
        alert("회원가입이 완료되었습니다!");
        navigate("/login");
      }
    } catch (error) {
      alert("회원가입 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="user_protected">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="back_btn"
        style={{
          background: "none",
          border: "none",
          fontSize: "20px",
          cursor: "pointer",
          marginBottom: "20px",
        }}
      >
        ←
      </button>

      <h2>보호대상자의 정보를<br />입력해주세요.</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder='보호대상자의 "이름"을 입력해주세요.'
          value={protectedData.name}
          onChange={handleChange}
        />
        <input
  type="date"
  name="birth"
  placeholder="생년월일을 입력해주세요."
  value={protectedData.birth}
  onChange={handleChange}
/>

        <button type="submit" className="submit_btn">
          가입하기
        </button>
      </form>
    </div>
  );
}
